import React from 'react';
import Link from 'next/link';
import cs1 from '../../assets/img/casestudy/2-1.png';
import cs2 from '../../assets/img/casestudy/2-2.png';
import cs3 from '../../assets/img/casestudy/2-3.png';

const CaseStudySection2 = () => {
    const caseStudies = [
        { id: 1, img: cs1, title: "BIM Modeling", location: "Heathrow Airport", link: "/casestudy/casestudy2" },
        { id: 2, img: cs2, title: "MEP Modeling, BIM Coordination", location: "Everett Alvarez", link: "/casestudy/casestudy2" },
        { id: 3, img: cs3, title: "Construction Drawings", location: "La Quinta Jackson", link: "/casestudy/casestudy2" },
        // Repeat items with dynamic links for future use
        { id: 4, img: cs1, title: "BIM Modeling", location: "Heathrow Airport", link: "/casestudy/casestudy2" },
        { id: 5, img: cs2, title: "MEP Modeling, BIM Coordination", location: "Everett Alvarez", link: "/casestudy/casestudy2" },
        { id: 6, img: cs3, title: "Construction Drawings", location: "La Quinta Jackson", link: "/casestudy/casestudy2" },
        { id: 7, img: cs1, title: "BIM Modeling", location: "Heathrow Airport", link: "/casestudy/casestudy2" },
        { id: 8, img: cs2, title: "MEP Modeling, BIM Coordination", location: "Everett Alvarez", link: "/casestudy/casestudy2" },
        { id: 9, img: cs3, title: "Construction Drawings", location: "La Quinta Jackson", link: "/casestudy/casestudy2" },
    ];

    return (
        <section className="casestudy-grid-section">
            <div className="casestudy-grid">
                {caseStudies.map((item) => (
                    <Link key={item.id} href={item.link} className="casestudy-card-link">
                        <div className="casestudy-card">
                            <div className="casestudy-card-img">
                                <img src={item.img.src || item.img} alt={item.title} />
                            </div>
                            <div className="casestudy-card-info">
                                <h3 className="casestudy-card-title">{item.title}</h3>
                                <div className="casestudy-card-divider"></div>
                                <p className="casestudy-card-location">{item.location}</p>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    );
};

export default CaseStudySection2;
